import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";

export function displayError(errorMessage, title) {
  let message = 'An unexpected error occurred.';
  let code = '';
  let detail = [];

  if (typeof errorMessage === 'string' && errorMessage.trim()) {
    if (errorMessage.includes('<!DOCTYPE html>') || errorMessage.includes('<html')) {
      const titleMatch = errorMessage.match(/<title>([^<]+)<\/title>/i);
      const titleText = titleMatch?.[1] || '';
      if (/not found|404/i.test(titleText)) {
        message = 'The requested API endpoint was not found. Restart the Django server if this report was recently added.';
      } else {
        message = titleText || 'The server returned an HTML error page.';
      }
    } else {
      message = errorMessage;
    }
  } else if (errorMessage && typeof errorMessage === 'object') {
    if (Array.isArray(errorMessage.message)) {
      message = errorMessage.message.map((item) => String(item)).join('; ');
    } else if (errorMessage.message !== undefined && errorMessage.message !== null && String(errorMessage.message).trim()) {
      message = String(errorMessage.message);
    } else if (typeof errorMessage.detail === 'string' && errorMessage.detail.trim()) {
      message = errorMessage.detail;
    } else if (Array.isArray(errorMessage.detail)) {
      message = 'Validation failed.';
      detail = errorMessage.detail;
    } else if (errorMessage.detail && typeof errorMessage.detail === 'object') {
      message = Object.entries(errorMessage.detail)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
    } else {
      try {
        const serialized = JSON.stringify(errorMessage);
        if (serialized && serialized !== '{}') {
          message = serialized;
        }
      } catch (e) {
        message = 'An unexpected error occurred.';
      }
    }

    if (errorMessage.code !== undefined && errorMessage.code !== null && errorMessage.code !== '') {
      code = errorMessage.code;
    } else if (errorMessage.status !== undefined && errorMessage.status !== null) {
      code = errorMessage.status;
    }

    if (Array.isArray(errorMessage.detail) && errorMessage.detail.length > 0) {
      detail = errorMessage.detail;
    }
  }

  let htmlContent = code
    ? `<b><i>${message} (Code: ${code})</i></b>`
    : `<b><i>${message}</i></b>`;

  if (detail.length > 0) {
    htmlContent += '<ul>';
    detail.forEach((detailItem) => {
      htmlContent += '<li>';
      if (typeof detailItem === 'object' && detailItem !== null) {
        Object.entries(detailItem).forEach(([key, value]) => {
          htmlContent += `<strong>${key}:</strong> ${value}<br>`;
        });
      } else {
        htmlContent += `${detailItem}`;
      }
      htmlContent += '</li>';
    });
    htmlContent += '</ul>';
  }

  Swal.fire({
    title: '<img src="/error-icon.png" width="110" height="60"/>' + title,
    html: htmlContent,
    customClass: {
      popup: 'swal-wide',
      icon: 'error',
    },
  });
}

export function resolveApiErrorMessage(error, fallback = 'An error occurred.') {
  if (!error) {
    return fallback;
  }
  if (typeof error === 'string' && error.trim()) {
    return error;
  }
  if (!error.response) {
    const networkMessage = error.message || '';
    if (/network error/i.test(networkMessage)) {
      return 'Cannot reach the API server. Start the Django backend on port 8000.';
    }
    return networkMessage || fallback;
  }
  const data = error.response.data;
  if (typeof data === 'string' && data.trim()) {
    return data;
  }
  if (data && typeof data === 'object') {
    if (data.error) {
      return String(data.error);
    }
    if (data.detail) {
      return String(data.detail);
    }
    if (data.message) {
      return String(data.message);
    }
  }
  return fallback;
}

export function displayErrorToast(titleMessage) {
  const message = resolveApiErrorMessage(titleMessage);
  const snackbar = document.getElementById("snackbar");
  const title = document.getElementById("snackbar-title");

  if (!snackbar || !title) {
    console.error(message);
    return;
  }

  const icon = document.getElementById("snackbar-icon");
  if (icon) {
    icon.src = "/error-icon.png";
    icon.height = '40';
    icon.width = '90';
  }

  title.innerText = message;
  snackbar.className = "show error";
  setTimeout(function () {
    snackbar.className = snackbar.className.replace("show", "");
  }, 3000);
}

export function displaySuccessToast(titleToast) {
  const message = titleToast == null ? 'Success.' : String(titleToast);
  const snackbar = document.getElementById("snackbar");
  const title = document.getElementById("snackbar-title");

  if (!snackbar || !title) {
    console.log(message);
    return;
  }

  const icon = document.getElementById("snackbar-icon");
  if (icon) {
    icon.src = "./img/success-icon.png";
    icon.height = '50';
    icon.width = '40';
  }

  title.innerText = message;
  snackbar.className = "show success";
  setTimeout(function () {
    snackbar.className = snackbar.className.replace("show", "");
  }, 3000);
}
    
export function parseBoolean(booleanString) {

  return (booleanString && String(booleanString).toLowerCase() === 'true');
}    
export function parseBooleanToString(booleanValue){
  return (booleanValue?'Yes':'No');
}

export function findStateFromGstPortal(stcd, states) {
  if (!stcd) {
    return null;
  }
  const stcdLower = String(stcd).toLowerCase();
  return (states || []).find((state) => {
    const stateLabel = state.value.split('(')[0].trim().toLowerCase();
    return state.value.slice(0, 3).toLowerCase() === String(stcd).slice(0, 3).toLowerCase()
      || stcdLower === stateLabel
      || stcdLower.includes(stateLabel)
      || stateLabel.includes(stcdLower);
  });
}

export function mapGstPortalCustomerFields(result) {
  const addr = result?.pradr?.addr || {};
  return {
    name: result?.tradeNam || result?.lgnm || '',
    address_1: addr.st || '',
    address_2: addr.loc || '',
    address_3: addr.dst || '',
    pincode: addr.pncd || '',
    gst_status: result?.sts || '',
    registration_type: result?.dty || '',
    stcd: addr.stcd || '',
  };
}
